import Component from "../abstracts/Component";
import { doAjax } from '../utils/ajaxUtil';
export default class PasswordRecoveryComponentHeader extends Component {
    get SELECTORS(){
        return {
            label: '.pwd-recovery-label',
            returnToLoginLbl: '.return-to-login-lbl',
            credentialsLayer: '.credentials-layer',
            forgotPasswordLayer: '.forgot-password-layer',
            btnSubmit: '.submit-recovery-psw',
            formClass: "#forgottenPwdForm",
            wrapperContent: ".f-p-l-wrapper-content",
            successFPsw: ".success-forgot-psw",
            wrtl: ".w-r-t-l-lbl",
            currentPswd: ".current_pwd",
            oldPswd: ".new_pwd",
            buttonPrimary: ".pwd-recovery-submit-btn",
            resetFormFields: '#forgottenPwdForm',
            btnSubmitHeader: ".submit-recovery-psw-h",
            fpwdFormLayer: ".fpwdForm-layer",
            formBtn: '[data-reset-send]',
        }
    }

    constructor() {
        super();
      }

    resetPwdFromHeader(){
         
        let buttonH = document.querySelectorAll(this.SELECTORS.btnSubmitHeader)
        let fpwdFormLayer = document.querySelector(this.SELECTORS.fpwdFormLayer)
        if(buttonH && fpwdFormLayer){
            fpwdFormLayer.addEventListener("submit",(e) => {
            e.preventDefault();
            let url = fpwdFormLayer.getAttribute("action");
            let params = new URLSearchParams(new FormData(fpwdFormLayer)).toString();
            let ctx = this;
            doAjax({
              url: url,
              data: {
                'email': fpwdFormLayer.querySelector('input[name=email]').value,
              },
              success: function (html) {
                ctx.log('Thanksss for resetpw...');
                // get the html
                let response = new DOMParser().parseFromString(html, 'text/html');
                let responseForm = response.querySelector(ctx.SELECTORS.responseForm);
                let resetForm = response.querySelector(ctx.SELECTORS.fpwdFormLayer);
                if ( responseForm != null ) {
                  let responseHtml = response.querySelector(ctx.SELECTORS.responseForm).innerHTML;
                  // replace html
                  ctx.myAccountLayerBox.innerHTML = responseHtml;
                  // remove force opening
                  setTimeout(function(){
                    ctx.myAccountLayerWrapper.classList.remove(ctx.CLASSES.opened);
                    ctx.formBox.classList.remove(ctx.CLASSES.sending);
                  },3000);
                }
                if ( resetForm != null ) {
                  let resetFormHtml = response.querySelector(ctx.SELECTORS.resetFormFields).innerHTML;
                  // replace html
                  document.querySelector(ctx.SELECTORS.resetFormFields).innerHTML = resetFormHtml;
                  // reset button
                  //let btn = document.querySelector(ctx.SELECTORS.formBtn);
                  //btn.classList.remove(ctx.CLASSES.adding);
                  // force opening
                  //ctx.myAccountLayerWrapper.classList.add(ctx.CLASSES.opened);
                }
              },
              error: function (html) {
                ctx.log('Resetpw submit error ',html);
              }
            });
          })
        }
    }

    render(){
        super.render();
        this.resetPwdFromHeader();
    }
}